export interface IQuestionnaireAnswer {
    taskID?: number;
    questionnaireJson: string;
    themeJson?: string;
    answersJson: string;
    isCompleted: boolean;
}

export class QuestionnaireAnswer implements IQuestionnaireAnswer {
    taskID: number;
    questionnaireJson: string;
    themeJson?: string;
    answersJson: string;
    isCompleted: boolean;

    constructor(data: QuestionnaireAnswer) {
        this.taskID = data.taskID;
        this.questionnaireJson = data.questionnaireJson;
        this.themeJson = data.themeJson;
        this.answersJson = data.answersJson;
        this.isCompleted = data.isCompleted || false;
    }
}

export interface IQuestionnaireAnswerPayload {
    taskID: number | null;
    invitationToken: null | string;
    answersJson: string;
    answers: IAnswer[];
    calculatedValues?: Record<string, any>;
}

export interface IAnswer {
    questionName: string;
    textAnswer: string;
    note: string;
}

export interface IQuestionnaireScore {
    taskID: number;
    questionnaireId: number;
    dateCompleted: string;
    score: number;
    category: string;
    scoreCount: number;
    shortName: string;
    scoringModeID: number;
}

export class QuestionnaireScore implements IQuestionnaireScore {
    taskID: number;
    questionnaireId: number;
    dateCompleted: string;
    score: number;
    category: string;
    scoreCount: number;
    shortName: string;
    scoringModeID: number;

    constructor(data: IQuestionnaireScore) {
        this.taskID = data.taskID;
        this.questionnaireId = data.questionnaireId;
        this.dateCompleted = data.dateCompleted;
        this.score = data.score;
        this.category = data.category;
        this.scoreCount = data.scoreCount;
        this.shortName = data.shortName;
        this.scoringModeID = data.scoringModeID || 1; // Default to Average mode
    }
}
